// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2XYRl","left":"StickyBox_left__1Vq4F","right":"StickyBox_right__3SUB-"};